import React, { useState, useEffect } from "react";
import { useAppDispatch } from "../Core/store.hooks";
import CadsListWidget from "./CadsListWidget";
import DashboardContainer from "../Common/Components/DashboardContainer";
import Filters from "./Filter";
import { toggleSidebar } from "../Common/Slices/SidebarSlice";
import { AuthApi } from "../Core/api";

const Search = () => {
  const dispatch = useAppDispatch();

  const positionData = [
    { col: 1, colSpan: 6, rowSpan: 12 },
    { col: 1, colSpan: 6, rowSpan: 12 },
  ];
    useEffect(() => {
        AuthApi.logUserEvent("MPE Search")

    }, []);
  useEffect(() => {
    dispatch<any>(toggleSidebar({ isOpen: true }));
  }, []);

  const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
    {
      title: "Filters",
      item: <Filters gridType="MPE Customer Assembly Devices" />,
      expanded: true,
    },
  ];
  const getDefaultWidgets = () => {
    return [<CadsListWidget id="3" header="MPE Customer Assembly Devices" />];
  };
  const defaultWidgets = getDefaultWidgets();

  return (
    <DashboardContainer
      sidebarItems={sidebarItems}
      positionData={positionData}
      defaultWidgets={defaultWidgets}
      addRemove={false}
      savable={false}
    />
  );
};

export default Search;
